<template>
  <svg
    v-if="category === 'pipe'"
    width="56"
    height="44"
    viewBox="0 0 56 44"
    aria-hidden="true"
  >
    <rect
      x="2"
      y="12"
      width="5"
      height="20"
      rx="1"
      :fill="pipeColor.fill"
      :stroke="pipeColor.stroke"
      stroke-width="1.5"
    />
    <line
      x1="2"
      y1="15"
      x2="7"
      y2="15"
      :stroke="pipeColor.stroke"
      stroke-width="0.8"
      opacity="0.5"
    />
    <line
      x1="2"
      y1="29"
      x2="7"
      y2="29"
      :stroke="pipeColor.stroke"
      stroke-width="0.8"
      opacity="0.5"
    />
    <rect
      x="49"
      y="12"
      width="5"
      height="20"
      rx="1"
      :fill="pipeColor.fill"
      :stroke="pipeColor.stroke"
      stroke-width="1.5"
    />
    <line
      x1="49"
      y1="15"
      x2="54"
      y2="15"
      :stroke="pipeColor.stroke"
      stroke-width="0.8"
      opacity="0.5"
    />
    <line
      x1="49"
      y1="29"
      x2="54"
      y2="29"
      :stroke="pipeColor.stroke"
      stroke-width="0.8"
      opacity="0.5"
    />
    <rect
      x="6"
      y="15"
      width="44"
      height="14"
      :fill="pipeColor.fill"
      :stroke="pipeColor.stroke"
      stroke-width="1.2"
    />
    <rect
      x="7"
      y="16"
      width="42"
      height="3"
      rx="1"
      fill="white"
      opacity="0.35"
    />
    <rect
      x="7"
      y="25"
      width="42"
      height="3"
      rx="1"
      :fill="pipeColor.stroke"
      opacity="0.2"
    />
  </svg>

  <svg
    v-else-if="category === 'fitting' && icon === 'elbow'"
    width="56"
    height="44"
    viewBox="0 0 56 44"
    aria-hidden="true"
  >
    <rect
      x="2"
      y="20"
      width="18"
      height="11"
      fill="#cbd5e1"
      stroke="#475569"
      stroke-width="1.2"
    />
    <rect
      x="1"
      y="17"
      width="5"
      height="17"
      rx="1"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.5"
    />
    <line
      x1="1"
      y1="20"
      x2="6"
      y2="20"
      stroke="#475569"
      stroke-width="0.8"
      opacity="0.5"
    />
    <line
      x1="1"
      y1="31"
      x2="6"
      y2="31"
      stroke="#475569"
      stroke-width="0.8"
      opacity="0.5"
    />
    <path
      d="M20 20 Q34 20 34 6"
      fill="none"
      stroke="#cbd5e1"
      stroke-width="11"
      stroke-linecap="butt"
    />
    <path
      d="M20 31 Q45 31 45 6"
      fill="none"
      stroke="#475569"
      stroke-width="1.2"
      stroke-linecap="butt"
    />
    <path
      d="M20 20 Q34 20 34 6"
      fill="none"
      stroke="#475569"
      stroke-width="1.2"
      stroke-linecap="butt"
    />
    <path
      d="M20 22 Q32 22 32 8"
      fill="none"
      stroke="white"
      stroke-width="3"
      opacity="0.3"
      stroke-linecap="butt"
    />
    <rect
      x="28"
      y="1"
      width="17"
      height="5"
      rx="1"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.5"
    />
    <line
      x1="31"
      y1="1"
      x2="31"
      y2="6"
      stroke="#475569"
      stroke-width="0.8"
      opacity="0.5"
    />
    <line
      x1="42"
      y1="1"
      x2="42"
      y2="6"
      stroke="#475569"
      stroke-width="0.8"
      opacity="0.5"
    />
  </svg>

  <svg
    v-else-if="category === 'fitting' && icon === 'elbow-45'"
    width="56"
    height="44"
    viewBox="0 0 56 44"
    aria-hidden="true"
  >
    <rect
      x="2"
      y="20"
      width="16"
      height="11"
      fill="#cbd5e1"
      stroke="#475569"
      stroke-width="1.2"
    />
    <rect
      x="1"
      y="17"
      width="5"
      height="17"
      rx="1"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.5"
    />
    <path
      d="M18 20 L42 4 L42 15 L18 31 Z"
      fill="#cbd5e1"
      stroke="#475569"
      stroke-width="1.2"
    />
    <path
      d="M19 22 L41 7"
      fill="none"
      stroke="white"
      stroke-width="3"
      opacity="0.3"
    />
    <rect
      x="38"
      y="1"
      width="16"
      height="5"
      rx="1"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.5"
      transform="rotate(-26 38 3)"
    />
  </svg>

  <svg
    v-else-if="category === 'fitting' && icon === 'tee'"
    width="56"
    height="44"
    viewBox="0 0 56 44"
    aria-hidden="true"
  >
    <rect
      x="2"
      y="20"
      width="52"
      height="11"
      fill="#cbd5e1"
      stroke="#475569"
      stroke-width="1.2"
    />
    <rect
      x="1"
      y="17"
      width="5"
      height="17"
      rx="1"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.5"
    />
    <line
      x1="1"
      y1="20"
      x2="6"
      y2="20"
      stroke="#475569"
      stroke-width="0.8"
      opacity="0.5"
    />
    <line
      x1="1"
      y1="31"
      x2="6"
      y2="31"
      stroke="#475569"
      stroke-width="0.8"
      opacity="0.5"
    />
    <rect
      x="50"
      y="17"
      width="5"
      height="17"
      rx="1"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.5"
    />
    <line
      x1="50"
      y1="20"
      x2="55"
      y2="20"
      stroke="#475569"
      stroke-width="0.8"
      opacity="0.5"
    />
    <line
      x1="50"
      y1="31"
      x2="55"
      y2="31"
      stroke="#475569"
      stroke-width="0.8"
      opacity="0.5"
    />
    <rect
      x="22"
      y="3"
      width="12"
      height="18"
      fill="#cbd5e1"
      stroke="#475569"
      stroke-width="1.2"
    />
    <rect
      x="18"
      y="1"
      width="20"
      height="5"
      rx="1"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.5"
    />
    <line
      x1="22"
      y1="1"
      x2="22"
      y2="6"
      stroke="#475569"
      stroke-width="0.8"
      opacity="0.5"
    />
    <line
      x1="34"
      y1="1"
      x2="34"
      y2="6"
      stroke="#475569"
      stroke-width="0.8"
      opacity="0.5"
    />
  </svg>

  <svg
    v-else-if="category === 'fitting' && icon === 'reducer'"
    width="56"
    height="44"
    viewBox="0 0 56 44"
    aria-hidden="true"
  >
    <path
      d="M8 12 L48 17 L48 27 L8 32 Z"
      fill="#cbd5e1"
      stroke="#475569"
      stroke-width="1.2"
    />
    <rect
      x="2"
      y="9"
      width="7"
      height="26"
      rx="1"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.5"
    />
    <line
      x1="2"
      y1="13"
      x2="9"
      y2="13"
      stroke="#475569"
      stroke-width="0.8"
      opacity="0.5"
    />
    <line
      x1="2"
      y1="31"
      x2="9"
      y2="31"
      stroke="#475569"
      stroke-width="0.8"
      opacity="0.5"
    />
    <rect
      x="47"
      y="14"
      width="7"
      height="16"
      rx="1"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.5"
    />
    <line
      x1="47"
      y1="17"
      x2="54"
      y2="17"
      stroke="#475569"
      stroke-width="0.8"
      opacity="0.5"
    />
    <line
      x1="47"
      y1="27"
      x2="54"
      y2="27"
      stroke="#475569"
      stroke-width="0.8"
      opacity="0.5"
    />
    <line
      x1="2"
      y1="22"
      x2="54"
      y2="22"
      stroke="#475569"
      stroke-width="0.8"
      stroke-dasharray="3 3"
      opacity="0.4"
    />
  </svg>

  <svg
    v-else-if="category === 'fitting' && icon === 'union'"
    width="56"
    height="44"
    viewBox="0 0 56 44"
    aria-hidden="true"
  >
    <rect
      x="2"
      y="20"
      width="11"
      height="11"
      fill="#cbd5e1"
      stroke="#475569"
      stroke-width="1.2"
    />
    <rect
      x="1"
      y="17"
      width="5"
      height="17"
      rx="1"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.5"
    />
    <rect
      x="43"
      y="20"
      width="11"
      height="11"
      fill="#cbd5e1"
      stroke="#475569"
      stroke-width="1.2"
    />
    <rect
      x="50"
      y="17"
      width="5"
      height="17"
      rx="1"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.5"
    />
    <polygon
      points="13,15 24,13 24,38 13,36"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.3"
    />
    <line x1="13" y1="21" x2="24" y2="20" stroke="#64748b" stroke-width="0.8" />
    <line x1="13" y1="30" x2="24" y2="29" stroke="#64748b" stroke-width="0.8" />
    <polygon
      points="43,15 32,13 32,38 43,36"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.3"
    />
    <line x1="43" y1="21" x2="32" y2="20" stroke="#64748b" stroke-width="0.8" />
    <line x1="43" y1="30" x2="32" y2="29" stroke="#64748b" stroke-width="0.8" />
    <line
      x1="28"
      y1="12"
      x2="28"
      y2="39"
      stroke="#475569"
      stroke-width="1.5"
      stroke-dasharray="3 2"
    />
  </svg>

  <svg
    v-else-if="category === 'fitting' && icon === 'coupling'"
    width="56"
    height="44"
    viewBox="0 0 56 44"
    aria-hidden="true"
  >
    <rect
      x="2"
      y="20"
      width="10"
      height="11"
      fill="#cbd5e1"
      stroke="#475569"
      stroke-width="1.2"
    />
    <rect
      x="1"
      y="17"
      width="5"
      height="17"
      rx="1"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.5"
    />
    <rect
      x="44"
      y="20"
      width="10"
      height="11"
      fill="#cbd5e1"
      stroke="#475569"
      stroke-width="1.2"
    />
    <rect
      x="50"
      y="17"
      width="5"
      height="17"
      rx="1"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.5"
    />
    <rect
      x="11"
      y="14"
      width="34"
      height="23"
      rx="2"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.5"
    />
    <rect
      x="12"
      y="15"
      width="32"
      height="7"
      rx="1"
      fill="white"
      opacity="0.18"
    />
    <line x1="18" y1="14" x2="18" y2="37" stroke="#64748b" stroke-width="0.8" />
    <line x1="24" y1="14" x2="24" y2="37" stroke="#64748b" stroke-width="0.8" />
    <line x1="32" y1="14" x2="32" y2="37" stroke="#64748b" stroke-width="0.8" />
    <line x1="38" y1="14" x2="38" y2="37" stroke="#64748b" stroke-width="0.8" />
    <line
      x1="2"
      y1="25.5"
      x2="54"
      y2="25.5"
      stroke="#475569"
      stroke-width="0.8"
      stroke-dasharray="3 3"
      opacity="0.4"
    />
  </svg>

  <svg
    v-else-if="category === 'fitting'"
    width="56"
    height="44"
    viewBox="0 0 56 44"
    aria-hidden="true"
  >
    <rect
      x="5"
      y="15"
      width="46"
      height="14"
      rx="2"
      fill="#cbd5e1"
      stroke="#475569"
      stroke-width="1.2"
    />
  </svg>

  <svg
    v-else-if="category === 'valve' && icon === 'ball-valve'"
    width="56"
    height="44"
    viewBox="0 0 56 44"
    aria-hidden="true"
  >
    <rect
      x="2"
      y="19"
      width="12"
      height="10"
      fill="#cbd5e1"
      stroke="#475569"
      stroke-width="1.2"
    />
    <rect
      x="42"
      y="19"
      width="12"
      height="10"
      fill="#cbd5e1"
      stroke="#475569"
      stroke-width="1.2"
    />
    <rect
      x="1"
      y="16"
      width="5"
      height="16"
      rx="1"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.5"
    />
    <rect
      x="50"
      y="16"
      width="5"
      height="16"
      rx="1"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.5"
    />
    <circle
      cx="28"
      cy="24"
      r="13"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.5"
    />
    <ellipse cx="28" cy="24" rx="4" ry="11" fill="#1e293b" opacity="0.7" />
    <ellipse cx="28" cy="24" rx="3" ry="10" fill="#0f172a" opacity="0.6" />
    <rect
      x="25"
      y="3"
      width="6"
      height="10"
      rx="1"
      fill="#64748b"
      stroke="#334155"
      stroke-width="1.2"
    />
    <rect
      x="15"
      y="2"
      width="26"
      height="5"
      rx="2.5"
      fill="#475569"
      stroke="#334155"
      stroke-width="1.2"
    />
    <path
      d="M20 18 Q28 14 36 18"
      fill="none"
      stroke="white"
      stroke-width="2"
      opacity="0.3"
      stroke-linecap="round"
    />
  </svg>

  <svg
    v-else-if="category === 'valve' && icon === 'gate-valve'"
    width="56"
    height="44"
    viewBox="0 0 56 44"
    aria-hidden="true"
  >
    <rect
      x="2"
      y="19"
      width="12"
      height="10"
      fill="#cbd5e1"
      stroke="#475569"
      stroke-width="1.2"
    />
    <rect
      x="42"
      y="19"
      width="12"
      height="10"
      fill="#cbd5e1"
      stroke="#475569"
      stroke-width="1.2"
    />
    <rect
      x="1"
      y="16"
      width="5"
      height="16"
      rx="1"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.5"
    />
    <rect
      x="50"
      y="16"
      width="5"
      height="16"
      rx="1"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.5"
    />
    <path
      d="M14 16 L42 16 L42 38 L28 43 L14 38 Z"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.5"
    />
    <polygon
      points="21,30 35,30 31,38 25,38"
      fill="#64748b"
      stroke="#334155"
      stroke-width="1"
    />
    <rect x="14" y="20" width="28" height="8" fill="#1e293b" opacity="0.35" />
    <rect
      x="23"
      y="7"
      width="10"
      height="12"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.2"
    />
    <rect
      x="26"
      y="1"
      width="4"
      height="9"
      fill="#64748b"
      stroke="#334155"
      stroke-width="1"
    />
    <circle
      cx="28"
      cy="3"
      r="7"
      fill="none"
      stroke="#334155"
      stroke-width="2"
    />
    <line x1="21" y1="3" x2="35" y2="3" stroke="#334155" stroke-width="1.5" />
    <line x1="28" y1="-4" x2="28" y2="10" stroke="#334155" stroke-width="1.5" />
    <circle
      cx="28"
      cy="3"
      r="2.5"
      fill="#64748b"
      stroke="#334155"
      stroke-width="1"
    />
  </svg>

  <svg
    v-else-if="category === 'valve' && icon === 'check-valve'"
    width="56"
    height="44"
    viewBox="0 0 56 44"
    aria-hidden="true"
  >
    <rect
      x="2"
      y="19"
      width="12"
      height="10"
      fill="#cbd5e1"
      stroke="#475569"
      stroke-width="1.2"
    />
    <rect
      x="42"
      y="19"
      width="12"
      height="10"
      fill="#cbd5e1"
      stroke="#475569"
      stroke-width="1.2"
    />
    <rect
      x="1"
      y="16"
      width="5"
      height="16"
      rx="1"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.5"
    />
    <rect
      x="50"
      y="16"
      width="5"
      height="16"
      rx="1"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.5"
    />
    <rect
      x="14"
      y="14"
      width="28"
      height="20"
      rx="2"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.5"
    />
    <rect x="14" y="19" width="28" height="10" fill="#1e293b" opacity="0.3" />
    <line x1="28" y1="15" x2="28" y2="34" stroke="#334155" stroke-width="1" />
    <path
      d="M28 16 L37 28 L28 34 Z"
      fill="#64748b"
      stroke="#334155"
      stroke-width="1"
    />
    <circle
      cx="28"
      cy="15.5"
      r="2"
      fill="#475569"
      stroke="#334155"
      stroke-width="1"
    />
    <path
      d="M16 24 L22 24 M20 21 L23 24 L20 27"
      fill="none"
      stroke="#2563eb"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <svg
    v-else-if="category === 'valve'"
    width="56"
    height="44"
    viewBox="0 0 56 44"
    aria-hidden="true"
  >
    <rect
      x="14"
      y="14"
      width="28"
      height="20"
      rx="2"
      fill="#94a3b8"
      stroke="#475569"
      stroke-width="1.5"
    />
  </svg>

  <svg
    v-else-if="category === 'pump' && icon === 'pump'"
    width="56"
    height="44"
    viewBox="0 0 56 44"
    aria-hidden="true"
  >
    <rect
      x="1"
      y="17"
      width="12"
      height="10"
      fill="#dbeafe"
      stroke="#1d4ed8"
      stroke-width="1.2"
    />
    <rect
      x="1"
      y="16"
      width="4"
      height="12"
      rx="1"
      fill="#93c5fd"
      stroke="#1d4ed8"
      stroke-width="1.5"
    />
    <rect
      x="24"
      y="1"
      width="10"
      height="14"
      fill="#dbeafe"
      stroke="#1d4ed8"
      stroke-width="1.2"
    />
    <rect
      x="22"
      y="1"
      width="14"
      height="4"
      rx="1"
      fill="#93c5fd"
      stroke="#1d4ed8"
      stroke-width="1.5"
    />
    <ellipse
      cx="31"
      cy="26"
      rx="18"
      ry="16"
      fill="#bfdbfe"
      stroke="#1d4ed8"
      stroke-width="1.8"
    />
    <path
      d="M31 26 Q46 18 48 28 Q50 36 42 39 Q34 42 31 42"
      fill="#93c5fd"
      stroke="#1d4ed8"
      stroke-width="1"
      opacity="0.6"
    />
    <ellipse cx="27" cy="20" rx="10" ry="7" fill="white" opacity="0.18" />
    <g transform="translate(31,26)">
      <line
        x1="0"
        y1="0"
        x2="0"
        y2="-10"
        stroke="#1d4ed8"
        stroke-width="2.5"
        stroke-linecap="round"
        transform="rotate(0)"
      />
      <line
        x1="0"
        y1="0"
        x2="0"
        y2="-10"
        stroke="#1d4ed8"
        stroke-width="2.5"
        stroke-linecap="round"
        transform="rotate(60)"
      />
      <line
        x1="0"
        y1="0"
        x2="0"
        y2="-10"
        stroke="#1d4ed8"
        stroke-width="2.5"
        stroke-linecap="round"
        transform="rotate(120)"
      />
      <line
        x1="0"
        y1="0"
        x2="0"
        y2="-10"
        stroke="#1d4ed8"
        stroke-width="2.5"
        stroke-linecap="round"
        transform="rotate(180)"
      />
      <line
        x1="0"
        y1="0"
        x2="0"
        y2="-10"
        stroke="#1d4ed8"
        stroke-width="2.5"
        stroke-linecap="round"
        transform="rotate(240)"
      />
      <line
        x1="0"
        y1="0"
        x2="0"
        y2="-10"
        stroke="#1d4ed8"
        stroke-width="2.5"
        stroke-linecap="round"
        transform="rotate(300)"
      />
      <circle r="4" fill="#1d4ed8" stroke="#1e40af" stroke-width="1" />
      <circle r="2" fill="#eff6ff" />
    </g>
  </svg>

  <svg
    v-else-if="category === 'pump' && icon === 'pump-pd'"
    width="56"
    height="44"
    viewBox="0 0 56 44"
    aria-hidden="true"
  >
    <rect
      x="1"
      y="17"
      width="10"
      height="10"
      fill="#fef9c3"
      stroke="#ca8a04"
      stroke-width="1.2"
    />
    <rect
      x="45"
      y="17"
      width="10"
      height="10"
      fill="#fef9c3"
      stroke="#ca8a04"
      stroke-width="1.2"
    />
    <rect
      x="8"
      y="10"
      width="40"
      height="24"
      rx="4"
      fill="#fef08a"
      stroke="#ca8a04"
      stroke-width="1.8"
    />
    <ellipse
      cx="21"
      cy="22"
      rx="8"
      ry="8"
      fill="#fde047"
      stroke="#ca8a04"
      stroke-width="1.2"
    />
    <ellipse
      cx="35"
      cy="22"
      rx="8"
      ry="8"
      fill="#fde047"
      stroke="#ca8a04"
      stroke-width="1.2"
    />
    <circle cx="21" cy="22" r="2.5" fill="#ca8a04" />
    <circle cx="35" cy="22" r="2.5" fill="#ca8a04" />
    <rect
      x="1"
      y="15"
      width="4"
      height="14"
      rx="1"
      fill="#fcd34d"
      stroke="#ca8a04"
      stroke-width="1.5"
    />
    <rect
      x="51"
      y="15"
      width="4"
      height="14"
      rx="1"
      fill="#fcd34d"
      stroke="#ca8a04"
      stroke-width="1.5"
    />
  </svg>

  <svg v-else width="56" height="44" viewBox="0 0 56 44" aria-hidden="true">
    <rect
      x="8"
      y="10"
      width="40"
      height="24"
      rx="4"
      fill="#e2e8f0"
      stroke="#475569"
      stroke-width="1.4"
    />
  </svg>
</template>

<script>
const DEFAULT_PIPE_COLOR = { fill: "#94a3b8", stroke: "#334155" };

export default {
  name: "CatalogIcon",
  props: {
    category: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: ""
    },
    pipeColor: {
      type: Object,
      default: () => DEFAULT_PIPE_COLOR
    }
  }
};
</script>
